import { render, staticRenderFns } from "./NewButton.vue?vue&type=template&id=67966742&"
import script from "./NewButton.vue?vue&type=script&lang=ts&"
export * from "./NewButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports